import React from 'react';
import { Chart } from "react-google-charts";

function PerformanceCharts(props) {
    let data = [["Semesters", "Semesters"]];
    const gradePoint = props.gradePoint

    gradePoint.map(item => {
        data.push([item.SemesterCode, item.GradePoint])
    });

    // const gradePoint = props.gpa
    // gradePoint.map(item => {
    //     data.push([item.SemesterCode, item.GPA])
    // });

    const options = {
        title: "STUDENT PERFORMANCE GRAPH",
        curveType: 'function',
        legend: { position: 'bottom' }
    };

    return (
        <>
{
   gradePoint.length > 0 ?

       <div className="col-md-12">
           <div className="card">
               <div className="card-body pb-0" >
                   <Chart
                       chartType="LineChart"
                       width="100%"
                       height="400px"
                       data={data}
                       options={options}/>
               </div>
           </div>
       </div>
            :<></>
                    }
        </>

    );
}
export default PerformanceCharts;